export default "__VITE_ASSET__Aot7gxT4__"